export const pageSecondaryHeaderTabContainerStyles = [
  "-mb-[calc(var(--page-header-padding)+var(--page-secondary-header-overflow-scroll-padding)+var(--page-header-bottom-border-width))]",
  "-mt-2 @xl/page-header:-mt-4 @6xl/page-header:mt-0"
]
